import React, { useEffect, useContext, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { connect } from "react-redux";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import Drawer from "@mui/material/Drawer";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import Badge from "@mui/material/Badge";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import AccountCircle from "@mui/icons-material/AccountCircle";
import Menu from "@mui/material/Menu";
import { MenuItem } from "@mui/material";
import { DatosCompradorContext } from "../context/Context";
import { Creators } from "../store/ducks/users";
import { filteredMenuItems } from "../views/MenuItems";
import { styles } from "../theme/styles";
import logoazul from "../assets/logoazul.png";
import Cookies from "js-cookie";
import { verifyToken } from "../helpers/jwtValidation.js";
import axios from "axios";

const Header = (props) => {
  const {
    resetDatos,
    tiendaAsociadaContext,
    rolContext,
    setTiendaAsociadaContext,
    setRolContext,
  } = useContext(DatosCompradorContext);
  const { menu, logout, userData, loginCookies } = props;
  const rol = userData.rol;
  const tiendaUsuario = userData.idNumber;
  const distrito = userData.distrito;
  const viewReporte = userData.viewReporte;
  const [notificacionesNoLeidas, setNotificacionesNoLeidas] = useState(0);
  const [loginCookie] = useState(Cookies.get("loginCookie"));
  const [anchorEl, setAnchorEl] = useState(null);
  const [auth] = useState(true);
  const [state, setState] = useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });
  const [isPedidosEnabled, setIsPedidosEnabled] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  // Login cookie
  useEffect(() => {
    if (loginCookie) loginCookies(loginCookie);
  }, []);

  // Refrescar sesión y cookie
  useEffect(() => {
    if (loginCookie) {
      setInterval(() => {
        const HoraActual = Date.now();
        const tiempoTranscurrido =
          (HoraActual - Cookies.get("sesion")) / 1000 / 60;
        if (tiempoTranscurrido && tiempoTranscurrido > 50)
          loginCookies(loginCookie);
      }, 300000);
    }

    const reloadInterval = setInterval(() => {
      if (!Cookies.get("loginCookie") && location.pathname !== "/") {
        window.location.reload();
      }
    }, 2000);

    return () => clearInterval(reloadInterval);
  }, []);

  // Inicialización tienda y rol
  useEffect(() => {
    if (!tiendaAsociadaContext || !rolContext) {
      const userDataDecoded = verifyToken(loginCookie).data.data;
      setTiendaAsociadaContext(userDataDecoded.sucursalAsignada);
      setRolContext(
        userDataDecoded.rol === "VENTA" ? "VENDEDOR/A" : userDataDecoded.rol,
      );

      const getDataEmpleado = async () => {
        await axios.get(
          `${process.env.REACT_APP_APP_EMPLEADOS}/${userDataDecoded.idNumber}`,
          {
            headers: {
              ApiKey: `${process.env.REACT_APP_APIKEYPETCOMPLETE}`,
              Authorization: `Bearer ${process.env.REACT_APP_AUTHPETCOMPLETE}`,
            },
          },
        );
      };
      getDataEmpleado();
    }
  }, [location.pathname]);
  // Toggle drawer
  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    )
      return;
    setState({ ...state, [anchor]: open });
  };
  const handleMenu = (event) => setAnchorEl(event.currentTarget);
  const handleClose = (event, shouldLogout = false) => {
    event.stopPropagation();
    setAnchorEl(null);
    if (shouldLogout) {
      logout();
      Cookies.remove();
      Cookies.remove("horaAux");
      Cookies.remove("selectedStore");
      Cookies.remove("inventoryCluster");
      Cookies.remove("sesion");
      Cookies.remove("hora");
      Cookies.remove("IDBUSCADO");
      localStorage.removeItem("encryptedArray");
      Cookies.remove("datosInvalidoss");
      localStorage.clear();
      resetDatos();
      navigate("/");
    }
  };
  // Horario pedidos
  useEffect(() => {
    const checkTimeRange = () => {
      const currentHour = new Date().getHours();
      setIsPedidosEnabled(currentHour >= 8 && currentHour < 22);
    };
    checkTimeRange();
    const interval = setInterval(checkTimeRange, 60000);
    return () => clearInterval(interval);
  }, []);

  /*useEffect(() => {
    if (!rol) return;
    if (rol === "SUPERVISOR" && !distrito) return;

    const fetchNotificaciones = async () => {
      try {
        const payload = { rol, userLogueado: tiendaUsuario };
        if (rol === "SUPERVISOR") {
          payload.distrito = distrito;
        }
        const { data } = await axios.post(
          `${process.env.REACT_APP_API_PETCOZOO}/reporteRecepcion/getAllOrdenesMongo`,
          payload,
          {
            headers: {
              Authorization: `Bearer ${process.env.REACT_APP_TOKEN}`,
              apikey: `${process.env.REACT_APP_APIKEY}`,
            },
          },
        );

        let ordenesFiltradas = [];
        let totalNoLeidos = 0;

        if (userData.rol === "STORE") {
          ordenesFiltradas.forEach((orden) => {
            if (orden.comentariosStore) {
              totalNoLeidos += orden.comentariosStore.filter(
                (c) => !c.leidoPorStore,
              ).length;
            }
          });
          //console.log("notificacionesNoLeidas: ", totalNoLeidos);

          //setNotificacionesNoLeidas(totalNoLeidos);
        } else if (userData.rol === "PROVIDER") {
          ordenesFiltradas = data.data.filter(
            (o) => o.proveedirId === userData.idNumber,
          );

          ordenesFiltradas.forEach((orden) => {
            if (orden.comentariosProvider) {
              totalNoLeidos += orden.comentariosProvider.filter(
                (c) => !c.leidoPorProvider,
              ).length;
            }
          });
        } else if (userData.rol === "ADMIN" || userData.rol === "SUPERVISOR") {
          // Todas las órdenes
          ordenesFiltradas = data.data;
          console.log("ordenesFiltradas: ", ordenesFiltradas);
          //let totalNoLeidos = 0;
          ordenesFiltradas.forEach((orden) => {
            if (orden.comentariosStore) {
              totalNoLeidos += orden.comentariosStore.filter(
                (c) => !c.leidoPorAdmin,
              ).length;
            }
            if (orden.comentariosProvider) {
              totalNoLeidos += orden.comentariosProvider.filter(
                (c) => !c.leidoPorAdmin,
              ).length;
            }
          });
        }
        //console.log("notificacionesNoLeidas: ", totalNoLeidos);
        setNotificacionesNoLeidas(totalNoLeidos);
        // Calcular total de comentarios no leídos
      } catch (err) {
        console.error("Error al obtener notificaciones:", err);
      }
    };
    fetchNotificaciones();
    const interval = setInterval(fetchNotificaciones, 60000);
    return () => clearInterval(interval);
  }, [rol, distrito]);*/

  const list = (anchor, menu) => (
    <Box
      sx={{ width: anchor === "top" || anchor === "bottom" ? "auto" : 250 }}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}>
      <List>
        {filteredMenuItems(menu)
          .filter((item) => {
            if (
              rol === "STORE" &&
              (viewReporte === false || !viewReporte) &&
              ["VERREPORTESRECEPCION", "REPORTERECEPCION"].includes(item.name)
            ) {
              return false;
            }

            return true;
          })
          .map((item) =>
            item.text !== "Formato de venta" ? (
              <ListItem key={item.text} disablePadding>
                <ListItemButton component={Link} to={item.route}>
                  <ListItemIcon>{item.icon}</ListItemIcon>
                  <ListItemText primary={item.text} />
                </ListItemButton>
              </ListItem>
            ) : isPedidosEnabled ? (
              <ListItem key={item.text} disablePadding>
                <ListItemButton component={Link} to={item.route}>
                  <ListItemIcon>{item.icon}</ListItemIcon>
                  <ListItemText primary={item.text} />
                </ListItemButton>
              </ListItem>
            ) : null,
          )}
      </List>
    </Box>
  );
  return (
    <div style={styles.header}>
      <AppBar position="static">
        <Toolbar style={styles.rep}>
          {/* Side drawer */}
          <div style={{ overflowY: "hidden" }}>
            {["left"].map((anchor) => (
              <React.Fragment key={anchor}>
                <IconButton
                  size="large"
                  edge="start"
                  color="inherit"
                  aria-label="menu">
                  <MenuIcon onClick={toggleDrawer(anchor, true)} />
                </IconButton>
                <Drawer
                  anchor={anchor}
                  open={state[anchor]}
                  onClose={toggleDrawer(anchor, false)}>
                  <AppBar sx={{ height: "10vh" }} position="static">
                    <Toolbar variant="dense"></Toolbar>
                  </AppBar>
                  <div>
                    {list(anchor, menu)}
                    <img
                      onClick={(e) => {
                        e.preventDefault();
                        navigate("/home");
                      }}
                      src={logoazul}
                      style={{
                        position: "absolute",
                        bottom: 0,
                        left: 50,
                        height: "12vh",
                        opacity: 0.2,
                      }}
                      alt="Logo"
                    />
                  </div>
                </Drawer>
              </React.Fragment>
            ))}
          </div>
          <p>
            <b
              onClick={(e) => {
                e.preventDefault();
                navigate("/home");
              }}
              style={{ cursor: "pointer" }}>
              PetcoZoo
            </b>
          </p>
          {auth && (
            <>
              <div>
                <IconButton
                  size="large"
                  aria-label="notificaciones"
                  aria-controls="menu-appbar"
                  aria-haspopup="true"
                  onClick={handleMenu}
                  color="inherit"
                  style={styles.head2}>
                  <Badge
                    badgeContent={notificacionesNoLeidas}
                    color="error"
                    invisible={notificacionesNoLeidas === 0}>
                    <AccountCircle /> {userData.idNumber}
                  </Badge>
                </IconButton>
                <Menu
                  id="menu-appbar"
                  anchorEl={anchorEl}
                  anchorOrigin={{ vertical: "top", horizontal: "right" }}
                  keepMounted
                  transformOrigin={{ vertical: "top", horizontal: "right" }}
                  open={Boolean(anchorEl)}
                  onClose={(event) => handleClose(event)}>
                  {["STORE", "ADMIN", "SUPERVISOR", "PROVIDER"].includes(
                    userData.rol,
                  ) && (
                    <MenuItem
                      onClick={(event) => {
                        event.stopPropagation();
                        setAnchorEl(null);
                        navigate("/visualizarReportesRecepcion");
                      }}>
                      Ver Notificaciones
                    </MenuItem>
                  )}
                  <MenuItem onClick={(event) => handleClose(event, true)}>
                    Cerrar Sesión
                  </MenuItem>
                </Menu>
              </div>
            </>
          )}
        </Toolbar>
      </AppBar>
    </div>
  );
};

const mapStateToProps = (state) => ({
  idNumber: state.users.idNumber,
  menu: state.users.menu,
  userData: state.users.data,
});

const creators = {
  logout: Creators.logout,
  login: Creators.login,
  loginCookies: Creators.loginCookies,
};

export default connect(mapStateToProps, creators)(Header);
